<template>
    <div class="mb-5">
        <div class="-my-2 py-2 sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
            <div class="align-middle inline-block min-w-full shadow rounded-lg bg-white">
                <div>
                    <div class="p-5">
                        <div class="relative">

							<div class="flex">
								<div class="pr-2">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/><path fill="none" d="M1 1h22v22H1z"/></svg>
								</div>
								<div class="text-md pb-4">
									Resync Profile with Google
								</div>
							</div>


                            <div class="flex justify-between">

                                <div class="pb-3">
									<div class="bg-gray-100 flex items-center p-2 rounded-lg">

										<div class="pr-3">
											<img v-if="user?.photoLink" :src="user?.photoLink" class="h-8 w-8 rounded-full border">
											<span v-else class="size-[38px] border rounded-full bg-gray-200 text-gray-600 flex justify-center items-center">{{ user?.name.charAt(0).toUpperCase() }}</span>
										</div>

										<div class="pr-6 text-left">
											<div class="text-xs text-gray-500">Name</div>
											<div class="text-sm text-gray-700">{{ user.name }}</div>
										</div>
										<div class="pr-6 text-left">
											<div class="text-xs text-gray-500">Google Email</div>
											<div class="text-sm text-gray-700">{{ user.googleEmail ?? user.email }}</div>
										</div>
									</div>

                                    <div v-if="errors" class="flex items-center p-3 bg-red-200 w-full rounded-md text-xs text-red-900">
                                        <div class="w-5 h-5 mr-3 text-red-800">
                                            <svg
                                                fill="none" stroke-linecap="round" stroke-linejoin="round"
                                                stroke-width="2" viewBox="0 0 24 24" stroke="currentColor">
                                                <path
                                                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                                            </svg>
                                        </div>
                                        <div>
                                            <div>{{this.errors}}</div>
                                        </div>
                                    </div>


                                </div>


                                <!-- Save button -->
                                <span>
                                    <button @click="resyncProfile()"
                                        :disabled="processingSave"
                                        :class="[processingSave ? 'cursor-not-allowed text-gray-100 bg-gray-100' : 'text-gray-700 bg-white hover:text-gray-500']"
                                        type="button"
                                        class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 text-base leading-6 font-medium shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                        Resync
                                        <svg class="w-4 h-4 ml-3 self-center" fill="none" stroke-linecap="round"
                                             stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
                                             stroke="currentColor">
                                            <path d="M9 5l7 7-7 7"></path>
                                        </svg>
                                        <div v-if="processingSave" class="dots absolute z-30 mt-1">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                    </button>
                                </span>
                            </div>

							<div class="text-xs italic text-gray-500">
								Note that your "Google Email" may be different than your email on SlideCub. This is common when you or your organization use an alias or have multiple domains available to you.
							</div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { router } from '@inertiajs/vue3'
    export default {
        name: "syncProfileFromGoogleCard",
        props: {
            user: null,
        },
        data() {
            return {
                name: '',
                processingSave: false,
                errors: null,
                success: false,
            }
        },
        mounted() {
            // this.name = this.user.name;
        },
        methods: {
            clear() {
                this.errors = null;
                this.success = false;
            },
            resyncProfile() {
                this.processingSave = true,
                    axios.post('/users/resyncWithGoogle')
                        .then((response) => {
                            this.processingSave = false;
                            this.success = true;
							Inertia.reload();

                        })
                        .catch((error) => {
                            this.errors = error.response.data
                            this.processingSave = false;
                        });
            },
        },
    }
</script>
